import React from 'react';

import { useHistory } from 'react-router-dom';
import { SideSpacer } from '../../components/common/Spacer';
import HeaderContainer from '../../containers/common/HeaderContainer';
import Navigation from '../../components/common/Navigation';
import {
  CommonContainer,
  HistoryBlock,
  NormalHistory,
} from '../../components/common/Container';
import MobileProductAdmissionContainer from '../../containers/app/MobileProductAdmissionContainer';
import AppNavbar from '../../components/app/AppNavBar'

const MobileProductAdmissionPage = () => {
  const user = JSON.parse(localStorage.getItem('user'));

  let history = useHistory();
  if (!user) {
    alert('잘못된 접근입니다 다시 로그인 해 주세요');
    history.push('/');
    return false;
  }
  
  return (
    <>
      <HeaderContainer />
      <Navigation />
      <SideSpacer>
        <CommonContainer style={{minWidth: '1340px'}}>
            <HistoryBlock>
              <NormalHistory style={{fontWeight: 'bold'}} >
                앱관리
              </NormalHistory>
            </HistoryBlock>
            <MobileProductAdmissionContainer history={history}/>
        </CommonContainer>
      </SideSpacer>
    </>
  );
};

export default MobileProductAdmissionPage;
